import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';
import About from './about';
import Service from './service';
import Products from './products';
import Contact from './contact';
import Berita from './blog';
import registerServiceWorker from './registerServiceWorker';
import './index.css';
import {
 BrowserRouter as Router,
 Route,Link,
} from 'react-router-dom'
ReactDOM.render(
 <Router>
 <div>
 <Route exact path="/" component={App} />
 <Route exact path="/about" component={About} />
 <Route exact path="/service" component={Service} />
 <Route exact path="/products" component={Products} />
 <Route exact path="/contact" component={Contact} />
 <Route exact path="/blog" component={Berita} />
 </div>
 </Router>
,document.getElementById('root'));
registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js